import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';

export const EXPENSES_ACTUALS_SUMMARY = gql`
  query expenseActualsSummary(
    $projectId: String!
    $dateRange: DateRangeInput2
    $currencyId: String
  ) {
    expenseActualsSummary(
      projectId: $projectId
      dateRange: $dateRange
      currencyId: $currencyId
    ) {
      currency {
        id
        symbol
        displayText
      }
      expenseCode {
        id
        displayText
      }
      billableAmount
      nonBillableAmount
    }
  }
`;

export const useExpenseActualsSummary = ({
  projectId,
  dateRange,
  currencyId
}) => {
  const { data, loading } = useQuery(EXPENSES_ACTUALS_SUMMARY, {
    variables: {
      projectId,
      dateRange,
      currencyId
    },
    skip: !projectId || !dateRange,
    errorPolicy: 'all',
    fetchPolicy: 'network-only'
  });

  const expenseActualsSummary = get(data, 'expenseActualsSummary', []);

  return {
    expenseActualsSummary,
    loading
  };
};

export default useExpenseActualsSummary;
